'use strict';

/**
 * @ngdoc service
 * @name gfcmsApp.dashboard.service
 * @description
 * # dashboard.service
 * Service in the gfcmsApp.
 */
angular.module('gfcmsApp')
  .service('dashboardService', function(BaseService, $http, $q, errorService) {

    var service = new BaseService();

    service.getWeatherByCity = getWeatherByCity;
    service.getWeatherByLatLong = getWeatherByLatLong;


    return service;

    function getWeatherByCity(cityName, cityLocation) {
      var queryString = 'city=' + cityName + '&country=' + cityLocation;

      return $http.get(service.baseUrl + '/dashboard/weather?' + queryString)
        .then(handleSuccess)
        .catch(handleError);
    }

    function getWeatherByLatLong() {

    }

    function handleSuccess(response) {
      return response.data;
    }

    function handleError(error, status) {
      return service.q.reject(errorService.handleError(error));
    }
  });
